// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb-page_breadcrumbs__k40se","list":"breadcrumb-page_list__o_DyB","points":"breadcrumb-page_points__E2zKc","noSlash":"breadcrumb-page_noSlash__OuwMV"};